import {ActionType} from '../../constants/ActionTypes'

export default function AccountReducer(state = {}, action) {
    switch (action.type) {
        //send code
        case ActionType.SEND_CODE_BEGIN:
            return {
                ...state,
                inProcess: true,
                isLoggedIn: false,
            };
        case ActionType.SEND_CODE_SUCCESS:
            return {
                ...state,
                inProcess: false,
                email: action.payload.Email,
            };
        case ActionType.SEND_CODE_FAILURE:
            return {
                ...state,
                inProcess: false,
                isLoggedIn: false,
                email: action.payload.Email,
                error: action.payload.Error
            };

        //recover password
        case ActionType.RECOVER_PASSWORD_BEGIN:
            return {
                ...state,
                inProcess: true,
                isLoggedIn: false,
            };
        case ActionType.RECOVER_PASSWORD_SUCCESS:
            return {
                ...state,
                inProcess: false,
                email: action.payload.Email,
                verificationKey: action.payload.VerificationCode,
                newPassword: action.payload.Password,
                confirmPassword: action.payload.ConfirmPassword,
            };
        case ActionType.RECOVER_PASSWORD_FAILURE:
            return {
                ...state,
                inProcess: false,
                isLoggedIn: false,
                email: action.payload.Email,
                verificationKey: action.payload.VerificationCode,
                newPassword: action.payload.Password,
                confirmPassword: action.payload.ConfirmPassword,
            };

        //Change password
        case ActionType.CHANGE_PASSWORD_BEGIN:
            return {
                ...state,
                inProcess: false,
            };
        case ActionType.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                inProcess: false,
                changePassword: {
                    ...action.payload
                }
            };
        case ActionType.CHANGE_PASSWORD_FAILURE:
            return {
                ...state,
                inProcess: false,
                changePassword: {
                    ...state.changePasswordData,
                    error: action.payload.error,
                }
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/subAffiliate/AccountReducer.js